import React, { useState, useEffect } from 'react';
import './style.sass';
import '../../ProductDetail/CreditCardPromotion/style.sass'
import { Link, useHistory, useLocation } from 'react-router-dom';
import ModalZipData from 'components/Modal';
import CurrencyFormat from 'react-currency-format';
import { useIsMobile } from 'hooks/useIsMobile';
import { BASE_PATH_PORTAL } from 'constants/general';

export default function ModuleZipPromotion(props) {
    const {
        sale_price,
        mensualidades
    } = props;

    const history = useHistory();
    const location = useLocation();
    const prevUrl = document.referrer;
    const urlLink = window.location.href;
    const hashLink = window.location.hash;
    const { isMobile } = useIsMobile();
    const [showModal, SetShowModal] = useState(false);
    const cuotas = mensualidades//sale_price / 4;

    
    const mostrarPromoZip = window["showPromoZip"];
    const textoPeriodoPromoZip1 = window["textoPeriodoPromoZip1"];
    const textoPeriodoPromoZip2 = window["textoPeriodoPromoZip2"];
    const montoMinimoPromoZip = window["montoMinimoPromoZip"];
    const montoMaximoPromoZip = window["montoMaximoPromoZip"];
    const montoMaxDescuentoPromoZip = window["montoMaxDescuentoPromoZip"];
    const porcentajeDescuentoPromoZip = window["porcentajeDescuentoPromoZip"];
    const showRulesPromoZip = window["showRulesPromoZip"];
    const LineText1PromoZip = window["LineText1PromoZip"];
    const LineText2PromoZip = window["LineText2PromoZip"];
    const LineText3PromoZip = window["LineText3PromoZip"];
    const LineText4PromoZip = window["LineText4PromoZip"];
    const LineText5PromoZip = window["LineText5PromoZip"];
    const LineText6PromoZip = window["LineText6PromoZip"];
    const LineText7PromoZip = window["LineText7PromoZip"];
    

    const showCreditCardData = () => {
        SetShowModal(true);
    }

    const handleClose = () => {
        history.push(location.pathname);
    }

    useEffect(() => {
        if (prevUrl === "") {
            if (hashLink === "#modalZipPromotion") {
                showCreditCardData();
            } else {
                SetShowModal(false);
            }
        } else {
            if (hashLink === "#modalZipPromotion") {
                showCreditCardData();
            } else {
                SetShowModal(false);
            }
        }
    }, [hashLink, urlLink])

    return (
        <>
            <div className="moduleCreditCardPromo">
                <Link to={"#modalZipPromotion"}  // href={BASE_PATH_PORTAL +"/c/zip/"} target="_blank" rel="noopener noreferrer"
                    className="lastMonthCreditCard"
                    onClick={showCreditCardData}
                >
                    <img src="/img/zip.png" alt="Logo Zip" loading="lazy" className="imaZip" />
                    <div>
                        {mostrarPromoZip === true && sale_price >= montoMinimoPromoZip
                            ?
                                sale_price >= montoMinimoPromoZip && sale_price <= montoMaximoPromoZip
                                    ? <p className="adicional"><span className="bold">-{porcentajeDescuentoPromoZip}%</span> adicional **</p>
                                    : sale_price >= (montoMaximoPromoZip + 1)
                                    && <p className="adicional"><span className="bold">- ${montoMaxDescuentoPromoZip}</span> en tu último pago**</p>
                                    // && null
                            : null
                        }
                        <p>4 X <CurrencyFormat
                            value={cuotas}
                            displayType={'text'}
                            thousandSeparator={true}
                            // prefix={'$'}
                            renderText={value => <span>{value}</span>}
                        /> <span>sin interés</span>
                        </p>
                    </div>
                </Link>

                {showModal &&
                    <ModalZipData onClose={handleClose} type={isMobile === "desktop" ? "zipModal" : "full"} title={isMobile === "desktop" ? "" : "Promociones Zip"}>
                        <div className="textEspecificacion dataModal11">
                            <div className="formasPagoZip">
                                {/* <img src="/img/zip2.png" loading="lazy" alt="logo zip" /> */}

                                {/* <h2>Compra ahora y paga después con Zip</h2> */}
                                {/* <p className="paddingTB16">Divide tu compra en 4 pagos sin intereses</p> */}

                                <p className="paddingTB15">Paga en quincenas sin intereses.</p>
                                {mostrarPromoZip === true && sale_price >= montoMinimoPromoZip
                                   ? sale_price >= montoMinimoPromoZip && sale_price <= montoMaximoPromoZip
                                        ? <p className="adicional"><span>Por {textoPeriodoPromoZip1} -{porcentajeDescuentoPromoZip}%</span> adicional{textoPeriodoPromoZip2} **</p>
                                        : sale_price >= (montoMaximoPromoZip + 1)
                                            && <p className="adicional"><span>Por {textoPeriodoPromoZip1} - ${montoMaxDescuentoPromoZip}</span> adicional{textoPeriodoPromoZip2}  **</p>
                                    : null
                                }
                                {/* <p className='adicional'>Cuesta de Enero con Zip.</p> */}
                                <ul>
                                    <li>Pago inicial de  {cuotas}*</li>
                                    <li>2do pago quincenal de {cuotas}*</li>
                                    <li>3er pago quincenal de {cuotas}*</li>
                                    <li>4to pago quincenal de {cuotas}*</li>
                                </ul>
                                <p className="costos">*Más costos de envío en pedidos menores a $499.00</p>
                                {/* {sale_price >= 1000 && sale_price <= 6000 && */}
                                <>
                                    {/* <p className='copys lineH18'>**Mínimo del ticket para participar &#62; $1,000.000 pesos mexicanos, a través del método de pago Zip.</p> */}
                                    {/* <p className='copys lineH18'>Vigencia del 16 de diciembre de 2021 al 19 de diciembre de 2021.</p> */}
                                    {/* <p className='copys lineH18'>Cashback el descuento que otorga Zip Co MX al Cliente: para las compras entre $1,000 MXN y hasta $6,000 MXN pesos el cliente obtendrá un 20% de descuento del valor total de su compra, para las compras superiores a $6,000 MXN pesos el cliente recibirá un descuento por $1200 MXN pesos reflejados en tu último pago.</p> */}
                                    {/* <p className='copys lineH18'>El descuento NO será entregado en efectivo al participante. Zip Co MX aplicará el descuento correspondiente en el último pago del Plan de Pagos o cuarta quincena programada del Cliente, siempre que Zip Co MX determine que el Cliente cumple con las condiciones convenidas en los presentes Términos y Condiciones y se verá reflejado en el plan de pago en un plazo máximo de quince días.</p> */}
                                    {/* <p className='copys lineH18'>Últimos Días de Navidad Zip</p>
                                     */}
                                    {/* <p className='copys lineH18'>
                                        *Válido del 9 al 20 de enero de 2022.
                                        Compras desde $1,000 MXN hasta $6,000 MXN obtiene un 20%, para compras superiores a $6,000 MXN obtén un descuento de $1200 pesos reflejados en tu último pago. Sujeto a Aprobación por Zip Co MX. CAT 0%. Aplican Términos y Condiciones. Las imágenes son ilustrativas..
                                    </p>  */}

                                </>
                                {/* } */}
                                {/* <p className="paddingTB15">Paga en quincenas sin intereses.</p> */}


                                {mostrarPromoZip === true && sale_price >= montoMinimoPromoZip
                                    ? 
                                        <>
                                            {showRulesPromoZip
                                                ?
                                                    <div className="contentTextZip">
                                                        {LineText1PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText1PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText2PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText2PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText3PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText3PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText4PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText4PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText5PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText5PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText6PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText6PromoZip} </p>
                                                            : null
                                                        }
                                                        {LineText7PromoZip?.length >= 1
                                                            ? <p className="costos lineH18 marginLine">{LineText7PromoZip} </p>
                                                            : null
                                                        }
                                                    </div>
                                                : null
                                            }
                                        </>
                                    : null
                                }
                                <>
                                    <h3>¿Cómo funciona Zip?</h3>
                                    <ul className="ulZip">
                                        <li>
                                            <img src="/img/zip_paso1.png" alt="paso 1" />
                                            <p>Llena tu carrito</p>
                                            {/* <p>Elige tu compra y selecciona Zip como método de pago</p> */}
                                        </li>

                                        <li>
                                            <img src="/img/zip_paso2.png" alt="paso 2" />
                                            <p>Elige Zip como forma de pago</p>
                                            {/* <p>Aprobación inmediata</p> */}
                                        </li>

                                        <li>
                                            <img src="/img/zip_paso3.png" alt="paso 3" />
                                            <p>Paga el 25% y llévatelo hoy</p>
                                            {/* <p>Primer pago al completar tu compra y los siguientes tres pagos de manera quincenal y sin intereses</p> */}
                                        </li>
                                    </ul>
                                </>
                            </div>

                            <p className="paddingLR costos">Para registrarte es necesario contar con una tarjeta de débito o crédito, tu INE y un número de celular mexicano. Aplican términos y condiciones. Visita www.zip.co</p>


                            <a href={BASE_PATH_PORTAL + "/c/zip/"} target="_blank" rel="noopener noreferrer" className="paddingLR conoceMas" >Conocer más de Zip</a>
                            {/* <div className="exampleZip">
                                <p className="">Ejemplo para compra de</p>
                                <h3 className="bold">4,000.00</h3>

                                <div class="step completedPrincipal active">
                                    <div class="v-stepper">
                                        <div class="circle"></div>
                                        <div class="line"></div>
                                    </div>

                                    <div class="content">
                                        <span>Primer pago <br></br><span className="small">Día de la Compra</span></span>
                                        <span className="spanPrecio">$1,000.00</span>
                                    </div>
                                </div>

                                <div class="step completed active">
                                    <div class="v-stepper">
                                        <div class="circlePeque"></div>
                                        <div class="line"></div>
                                    </div>

                                    <div class="content">
                                        <span>1 quincena después</span>
                                        <span className="spanPrecio">$1,000.00</span>
                                    </div>
                                </div>

                                <div class="step completed active">
                                    <div class="v-stepper">
                                        <div class="circlePeque"></div>
                                        <div class="line"></div>
                                    </div>

                                    <div class="content">
                                        <span>2 quincenas después</span>
                                        <span className="spanPrecio">$1,000.00</span>
                                    </div>
                                </div>

                                <div class="step completed active">
                                    <div class="v-stepper">
                                        <div class="circlePeque"></div>
                                        <div class="line"></div>
                                    </div>

                                    <div class="content">
                                        <span>2 quincenas después</span>
                                        <span className="spanPrecio">$1,000.00</span>
                                    </div>
                                </div>

                            </div> */}

                            {/* <p className="Copyright">Copyright © Zip Co Limited 2020</p> */}
                        </div>
                    </ModalZipData>}

            </div>

        </>
    )
};